import styled from 'styled-components';

//helpers
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

export const PageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
  padding: 60px 0;
  background-color: rgb(${getToken('color-background-secondary-inverted')});
  background-image: url(/${(props) => props.bg.small});
  background-position: center center;
  background-size: cover;

  ${screen.md} {
    background-image: url(/${(props) => props.bg.medium});
    padding: 100px 0;
  }

  ${screen.lg} {
    background-image: url(/${(props) => props.bg.large});
  }

  ${screen.xxlg} {
    background-image: url(/${(props) => props.bg.xxlarge});
  }
`;

export const Title = styled.h1`
  color: #eaf4f1;
  font-family: ${getToken('platform-font-title')};
  width: 100%;
  font-size: 50px;
  font-weight: ${getToken('font-weight-bold')};
  line-height: 54px;
  letter-spacing: -1.16px;
  margin: 16px auto;

  ${screen.md} {
  }

  ${screen.xxlg} {
  }
`;

export const Tag = styled.span`
  color: rgb(${getToken('color-brand')});
  font-family: ${getToken('platform-font-title')};
  font-weight: ${getToken('font-weight-regular')};
  margin: 0 auto;
  text-align: center;
  line-height: 21px;
  letter-spacing: 6px;
  text-transform: uppercase;
  font-size: 16px;

  ${screen.md} {
    font-size: 20px;
  }
`;

export const CTAWrapper = styled.div`
  margin: 36px auto 0;
`;
